import { render, staticRenderFns } from "./WhatsappNewsletterForm.vue?vue&type=template&id=f840c1ba&scoped=true&"
import script from "./WhatsappNewsletterForm.vue?vue&type=script&lang=js&"
export * from "./WhatsappNewsletterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f840c1ba",
  null
  
)

export default component.exports